module.exports = __webpack_public_path__ + "static/media/downButtonHover.d3c79229.svg";